import React, { Component } from 'react';
import cn from 'classnames';
import { Icon } from 'ui';
import trackEvent from 'misc/trackEvent';
import OptionsPopover from './OptionsPopover';
import DefaultViewProvider from './DefaultViewProvider';

const DefaultViewWrapper = ({ children }) => (
  <div
    className={cn(
      'DefaultContentView bdrs-top',
      'ml-a DefaultContentView-improved-search',
      'DefaultContentView-border-bottom',
    )}
  >
    {children}
  </div>
);

class DefaultContentView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverVisible: false,
    };
    this.togglePopover = this.togglePopover.bind(this);
  }

  togglePopover(currentView) {
    if (!this.state.popoverVisible) {
      trackEvent('default_content_view/open_popover_clicked', {
        location: 'Content Page - Save Default Experiment',
        button_state: currentView,
      });
    }

    this.setState(state => ({ popoverVisible: !state.popoverVisible }));
  }

  render() {
    return (
      <DefaultViewWrapper>
        <div className="pos-r ml-a">
          <DefaultViewProvider>
            {({ match, viewTypes, currentView }) => (
              <button
                type="button"
                className="u-linkBtn fw-b c-white td-u"
                onClick={() => this.togglePopover(currentView)}
              >
                {match({
                  [viewTypes.SET]: I18n.t('default_content_view.default'),
                  [viewTypes.UNSET]: I18n.t('default_content_view.not_set'),
                  [viewTypes.DIRTY]: I18n.t('default_content_view.unsaved'),
                })}
                <Icon name="caret_down" className="ml-4" />
              </button>
            )}
          </DefaultViewProvider>

          {this.state.popoverVisible && (
            <OptionsPopover onDismiss={this.togglePopover} />
          )}
        </div>
      </DefaultViewWrapper>
    );
  }
}

export default DefaultContentView;
